module.exports = __webpack_public_path__ + "img/icon-user-mail.53303eda.svg";